import { render, staticRenderFns } from "./FormPP.vue?vue&type=template&id=52d87fa6"
import script from "./FormPP.vue?vue&type=script&lang=js"
export * from "./FormPP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports